import {
  EnrollmentPickup,
  EnrollmentPickupInput
} from '../../lib/types/models/enrollment/enrollment-pickup'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateEnrollmentPickup({ id, ...data }: UpdateInput<EnrollmentPickupInput>) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.updateEnrollmentPickup.url, { id }))
    .patch<EnrollmentPickup, Partial<EnrollmentPickupInput>>(data)
}
